export default __webpack_public_path__ + "static/media/mp4.6d315cd0.svg";